module.exports = __webpack_public_path__ + "static/empanada-53a3033cd3faa12fb0c1851cb7f605b0.jpg";